module.exports = __webpack_public_path__ + "static/media/won.370546b1.mp3";